<template>
  <div class="partner">
    <img v-if="this.icon" class="partner__logo" :src="require(`@/create/assets/icons/${this.icon}.svg`)">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ['icon'],
  
}
</script>
<style lang="scss" scoped>

</style>
